import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useTheme } from '../context/ThemeContext.js';
import { useGoogleOneTapLogin } from '@react-oauth/google';
import { useNavigate, Link } from 'react-router-dom';
import { AuthCard } from './Login.js';
import API_BASE from '../api.js';






/* ─── animation keyframes ─── */

const STYLES = `

  @keyframes fadeUp   { from { opacity:0; transform:translateY(28px) } to { opacity:1; transform:none } }

  @keyframes fadeIn   { from { opacity:0 } to { opacity:1 } }

  @keyframes pulse    { 0%,100% { opacity:1 } 50% { opacity:0.4 } }

  @keyframes spin     { to { transform:rotate(360deg) } }

  @keyframes ctaGlow  { 0%,100% { box-shadow:0 0 0 0 rgba(79,70,229,0.45),0 8px 24px rgba(79,70,229,0.30) } 50% { box-shadow:0 0 0 7px rgba(79,70,229,0),0 8px 24px rgba(79,70,229,0.30) } }

  .am-cta-btn { animation: ctaGlow 2.2s ease-in-out infinite; }
  .am-cta-btn:hover { transform:translateY(-2px) scale(1.02) !important; box-shadow:0 12px 32px rgba(79,70,229,0.45) !important; animation:none !important; }

  @keyframes starShine { 0%,100% { filter:brightness(1); } 50% { filter:brightness(2) drop-shadow(0 0 4px #f59e0b); } }
  .am-star { display:inline-block; animation:starShine 1.6s ease-in-out infinite; }
  .am-star:nth-child(1) { animation-delay:0s; }
  .am-star:nth-child(2) { animation-delay:0.22s; }
  .am-star:nth-child(3) { animation-delay:0.44s; }
  .am-star:nth-child(4) { animation-delay:0.66s; }
  .am-star:nth-child(5) { animation-delay:0.88s; }

  .am-flip-wrap  { perspective:900px; }
  .am-flip-inner { position:relative; transform-style:preserve-3d; transition:transform 0.7s cubic-bezier(0.4,0.2,0.2,1); height:72px; }
  .am-flip-inner.flipped { transform:rotateY(180deg); }
  .am-flip-front { backface-visibility:hidden; -webkit-backface-visibility:hidden; position:absolute; inset:0; display:flex; align-items:center; }
  .am-flip-back  { backface-visibility:hidden; -webkit-backface-visibility:hidden; transform:rotateY(180deg); position:absolute; inset:0; display:flex; align-items:center; }

  @keyframes dot1     { 0%,80%,100% { transform:scale(0) } 40% { transform:scale(1) } }

  .am-typing-dot:nth-child(1) { animation: dot1 1.2s infinite }

  .am-typing-dot:nth-child(2) { animation: dot1 1.2s infinite 0.2s }

  .am-typing-dot:nth-child(3) { animation: dot1 1.2s infinite 0.4s }



  h1, h2, h3, h4, h5, p, span, div, button, a, input, label {

    font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;

  }



  .am-chip-hover:hover  { transform:scale(1.04); box-shadow:0 4px 14px rgba(79,70,229,0.15) !important }

  .am-btn-primary:hover { transform:translateY(-2px); box-shadow:0 16px 32px -4px rgba(79,70,229,0.40) !important }

  .am-btn-ghost:hover   { border-color:#4f46e5 !important; color:#4f46e5 !important }

  .am-bento:hover       { transform:translateY(-3px); box-shadow:0 20px 40px -8px rgba(15,23,42,0.10) !important }

  .am-tab:hover         { background:rgba(79,70,229,0.06) !important }

  .am-feature:hover .am-feature-icon { transform:scale(1.15) rotate(-4deg) }

  .am-price-card { transition: transform 0.22s, box-shadow 0.22s; }
  .am-price-card:hover { transform: translateY(-6px); box-shadow: 0 28px 56px rgba(0,0,0,0.45) !important; }
  .am-price-btn:hover  { opacity: 0.88; transform: translateY(-1px); }
  .am-price-btn-dark:hover { background: rgba(255,255,255,0.15) !important; }



  .am-bento-grid {

    display: grid;

    grid-template-columns: repeat(12, 1fr);

    gap: 16px;

    grid-auto-rows: minmax(140px, auto);

  }

  .am-bc-7 { grid-column: span 7 }

  .am-bc-5 { grid-column: span 5 }

  .am-bc-4 { grid-column: span 4 }

  .am-bc-3 { grid-column: span 3 }

  @media (max-width: 900px) {

    .am-bento-grid { grid-template-columns: repeat(2, 1fr); }

    .am-bc-7, .am-bc-5 { grid-column: span 2 }

    .am-bc-4, .am-bc-3 { grid-column: span 1 }

  }

  @media (max-width: 520px) {

    .am-bento-grid { grid-template-columns: 1fr; }

    .am-bc-7, .am-bc-5, .am-bc-4, .am-bc-3 { grid-column: span 1 }

  }



  .am-steps-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }

  @media (max-width: 680px) { .am-steps-grid { grid-template-columns: 1fr; gap: 14px; } }



  .am-twin-grid { display: flex; gap: 0; align-items: stretch; }

  .am-twin-col { flex: 1; padding: 28px 28px; display: flex; flex-direction: column; gap: 16px; }

  .am-twin-sep { width: 1px; background: #e8edf3; flex-shrink: 0; margin: 24px 0; }

  @media (max-width: 620px) {

    .am-twin-grid { flex-direction: column; }

    .am-twin-col  { padding: 20px 18px; }

    .am-twin-sep  { width: auto; height: 1px; margin: 0; }

  }



  .am-compare-grid { display: grid; grid-template-columns: 1fr 1fr; }

  .am-compare-cell { padding: 14px 20px; }

  .am-compare-header { padding: 14px 20px; }

  @media (max-width: 520px) {

    .am-compare-cell   { padding: 9px 10px !important; }

    .am-compare-header { padding: 10px 10px !important; }

    .am-compare-text   { font-size: 0.72rem !important; line-height: 1.4 !important; }

    .am-compare-topic  { font-size: 0.5rem !important; }

    .am-compare-title  { font-size: 0.78rem !important; }

  }



  .am-panel-mock { padding: 20px 22px; }

  @media (max-width: 480px) { .am-panel-mock { padding: 14px 10px; } }

  .am-nav-desktop { display: flex; align-items: center; gap: 6px; }
  .am-nav-mobile  { display: none; }
  @media (max-width: 540px) {
    .am-nav-desktop { display: none !important; }
    .am-nav-mobile  { display: block !important; }
  }

  .am-trust-row { display: flex; gap: 20px; flex-wrap: wrap; }
  @media (max-width: 480px) { .am-trust-row { gap: 12px; } }

  .am-hero-placeholder { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 10px; background: linear-gradient(135deg,#eef2ff,#e0e8ff); }

  /* ─── Scrollable page layout ─── */
  .am-section { padding: clamp(52px,8vw,96px) clamp(20px,5vw,40px); }
  .am-container { max-width: 1120px; margin: 0 auto; width: 100%; box-sizing: border-box; }

  .am-hero-grid { display: grid; grid-template-columns: 1fr 1.05fr; gap: clamp(36px,5vw,72px); align-items: center; }
  @media (max-width: 800px) { .am-hero-grid { grid-template-columns: 1fr; } }

  .am-stats-bar { display: grid; grid-template-columns: repeat(4, 1fr); }
  .am-stat-cell { padding: clamp(20px,3vw,32px) clamp(12px,2vw,24px); border-right: 1px solid #e2e8f0; text-align: center; }
  .am-stat-cell:last-child { border-right: none; }
  @media (max-width: 680px) {
    .am-stats-bar { grid-template-columns: 1fr 1fr; }
    .am-stat-cell:nth-child(2) { border-right: none; }
    .am-stat-cell:nth-child(3) { border-right: 1px solid #e2e8f0; border-top: 1px solid #e2e8f0; }
    .am-stat-cell:nth-child(4) { border-top: 1px solid #e2e8f0; border-right: none; }
  }

  .am-steps-row { display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px; }
  @media (max-width: 720px) { .am-steps-row { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 400px) { .am-steps-row { grid-template-columns: 1fr; } }

  .am-modules-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  @media (max-width: 700px) { .am-modules-grid { grid-template-columns: 1fr; gap: 16px; } }

  .am-pricing-grid-lp { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; }
  @media (max-width: 900px) { .am-pricing-grid-lp { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 520px) { .am-pricing-grid-lp { grid-template-columns: 1fr; } }

  .am-feature-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }
  @media (max-width: 640px) { .am-feature-grid { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 380px) { .am-feature-grid { grid-template-columns: 1fr; } }

  .am-section-label { display: inline-flex; align-items: center; gap: 7px; background: rgba(79,70,229,0.09); border: 1px solid rgba(99,102,241,0.28); border-radius: 99px; padding: 5px 14px; font-size: 0.7rem; font-weight: 700; color: #4f46e5; letter-spacing: 0.04em; margin-bottom: 16px; }

  .am-step-card { background: #fff; border: 1px solid #e2e8f0; border-radius: 18px; padding: clamp(18px,2.5vw,28px); display: flex; flex-direction: column; gap: 12px; box-shadow: 0 2px 12px rgba(15,23,42,0.05); transition: transform 0.2s, box-shadow 0.2s; }
  .am-step-card:hover { transform: translateY(-4px); box-shadow: 0 16px 40px rgba(15,23,42,0.10); }

  .am-module-card-lp { background: #fff; border: 1px solid #e2e8f0; border-radius: 20px; padding: clamp(20px,2.5vw,32px); display: flex; flex-direction: column; gap: 14px; box-shadow: 0 2px 12px rgba(15,23,42,0.05); transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s; }
  .am-module-card-lp:hover { transform: translateY(-5px); box-shadow: 0 20px 48px rgba(15,23,42,0.11); }

  .am-feat-card { background: rgba(255,255,255,0.07); border: 1px solid rgba(255,255,255,0.1); border-radius: 16px; padding: clamp(18px,2vw,24px); display: flex; flex-direction: column; gap: 10px; transition: background 0.2s; }
  .am-feat-card:hover { background: rgba(255,255,255,0.12); }

  /* ─── Mesh blobs ─── */
  @keyframes blob1 { 0%,100%{transform:translate(0,0) scale(1)} 25%{transform:translate(44px,-68px) scale(1.09)} 75%{transform:translate(-28px,48px) scale(0.93)} }
  @keyframes blob2 { 0%,100%{transform:translate(0,0) scale(1)} 33%{transform:translate(-58px,38px) scale(1.11)} 66%{transform:translate(38px,-48px) scale(0.90)} }
  @keyframes blob3 { 0%,100%{transform:translate(0,0) scale(1)} 40%{transform:translate(26px,-36px) scale(1.08)} 80%{transform:translate(-48px,58px) scale(0.95)} }
  .am-blob { position:absolute; border-radius:50%; filter:blur(88px); pointer-events:none; will-change:transform; }
  .am-blob-1 { width:660px; height:660px; background:radial-gradient(circle,rgba(79,70,229,0.58) 0%,transparent 68%); top:-190px; left:-130px; animation:blob1 14s ease-in-out infinite; }
  .am-blob-2 { width:520px; height:520px; background:radial-gradient(circle,rgba(124,58,237,0.52) 0%,transparent 68%); top:60px; right:-90px; animation:blob2 11s ease-in-out infinite; }
  .am-blob-3 { width:440px; height:440px; background:radial-gradient(circle,rgba(37,99,235,0.44) 0%,transparent 68%); bottom:-110px; left:38%; animation:blob3 17s ease-in-out infinite; }

  /* ─── Glass ─── */
  .am-glass-dark { background:rgba(255,255,255,0.055); backdrop-filter:blur(20px); -webkit-backdrop-filter:blur(20px); border:1px solid rgba(255,255,255,0.10); }
  .am-glass-dark:hover { background:rgba(255,255,255,0.09); border-color:rgba(255,255,255,0.16); }

  /* ─── Bento grid ─── */
  .am-bento-lp { display:grid; grid-template-columns:repeat(3,1fr); gap:14px; }
  .am-bento-span2 { grid-column:span 2; }
  .am-bento-tall  { grid-row:span 2; }
  @media(max-width:680px){ .am-bento-lp{grid-template-columns:1fr} .am-bento-span2,.am-bento-tall{grid-column:span 1;grid-row:span 1} }

  /* ─── Stats glass grid ─── */
  .am-stats-glass-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:12px; }
  @media(max-width:700px){ .am-stats-glass-grid{grid-template-columns:1fr 1fr} }

  /* ─── Gradient text ─── */
  .am-g-indigo { background:linear-gradient(135deg,#818cf8,#a78bfa); -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; }
  .am-g-violet  { background:linear-gradient(135deg,#a78bfa,#c4b5fd); -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; }
  .am-g-blue    { background:linear-gradient(135deg,#60a5fa,#38bdf8); -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; }
  .am-g-green   { background:linear-gradient(135deg,#34d399,#6ee7b7); -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; }
  .am-g-hero    { background:linear-gradient(135deg,#818cf8 0%,#a78bfa 42%,#60a5fa 100%); -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; }

  /* ─── Dark label ─── */
  .am-label-dark { display:inline-flex; align-items:center; gap:7px; background:rgba(79,70,229,0.18); border:1px solid rgba(99,102,241,0.32); border-radius:99px; padding:5px 14px; font-size:0.7rem; font-weight:700; color:#a5b4fc; letter-spacing:0.04em; margin-bottom:16px; }

  /* ─── Marquee ticker ─── */
  @keyframes ticker { 0%{transform:translateX(0)} 100%{transform:translateX(-50%)} }
  .am-ticker { overflow:hidden; position:relative; }
  .am-ticker-track { display:flex; width:max-content; animation:ticker 26s linear infinite; align-items:center; }
  .am-ticker-track:hover { animation-play-state:paused; }
  .am-ticker-item { display:flex; align-items:center; gap:10px; padding:0 clamp(28px,5vw,56px); border-right:1px solid #e2e8f0; white-space:nowrap; flex-shrink:0; }

  /* ─── What you get bento ─── */
  .am-wyg-bento { display:flex; flex-direction:column; gap:8px; max-width:600px; margin:0 auto; }
  @media(max-width:380px){ .am-wyg-bento{grid-template-columns:1fr} }

  /* ─── Sticker ─── */
  @keyframes stickerWobble { 0%,100%{transform:rotate(-12deg) scale(1)} 50%{transform:rotate(-7deg) scale(1.05)} }
  @keyframes stickerFlip {
    0%,30%   { transform:rotateY(0deg); }
    42%,58%  { transform:rotateY(180deg); }
    70%,100% { transform:rotateY(360deg); }
  }
  .am-sticker-wobble { position:absolute; top:-20px; right:-20px; width:94px; height:94px; animation:stickerWobble 4s ease-in-out infinite; cursor:default; user-select:none; z-index:10; }
  .am-sticker-persp  { width:100%; height:100%; perspective:500px; }
  .am-sticker-flip   { width:100%; height:100%; position:relative; transform-style:preserve-3d; animation:stickerFlip 8s ease-in-out infinite; }
  .am-sticker-face   { position:absolute; inset:0; border-radius:50%; background:linear-gradient(135deg,#2563eb,#4f46e5); color:#fff; display:flex; flex-direction:column; align-items:center; justify-content:center; text-align:center; padding:8px; box-shadow:0 6px 24px rgba(37,99,235,0.45),inset 0 1px 0 rgba(255,255,255,0.2); backface-visibility:hidden; -webkit-backface-visibility:hidden; }
  .am-sticker-back   { transform:rotateY(180deg); }

  /* ─── Stats responsive ─── */
  .am-stats-clean { display:grid; grid-template-columns:repeat(4,1fr); gap:12px; }
  @media(max-width:640px){ .am-stats-clean{grid-template-columns:1fr 1fr} }

  /* ─── HIW (How it works) ─── */
  .am-hiw-grid { display:grid; grid-template-columns:1fr 1fr; gap:clamp(28px,5vw,64px); align-items:start; }
  @media(max-width:700px){ .am-hiw-grid{grid-template-columns:1fr} }
  .am-hiw-step { display:flex; align-items:flex-start; gap:13px; padding:15px 16px; border-radius:12px; cursor:pointer; transition:background 0.2s; }
  .am-hiw-step:hover { background:#f0f4ff; }
  .am-hiw-step.active { background:#eff6ff; }
  .am-hiw-num { min-width:28px; height:28px; border-radius:50%; display:flex; align-items:center; justify-content:center; font-size:0.68rem; font-weight:900; flex-shrink:0; transition:background 0.2s,color 0.2s; }
  .am-hiw-step.active .am-hiw-num { background:#2563eb; color:#fff; }
  .am-hiw-step:not(.active) .am-hiw-num { background:#f1f5f9; color:#94a3b8; }
  .am-hiw-step h3 { font-size:0.93rem; font-weight:800; margin:0 0 4px; letter-spacing:-0.01em; transition:color 0.2s; }
  .am-hiw-step.active h3 { color:#0f172a; }
  .am-hiw-step:not(.active) h3 { color:#94a3b8; }
  .am-hiw-step p { font-size:0.78rem; color:#64748b; line-height:1.65; margin:0; }
  .am-hiw-panel { background:#fff; border:1.5px solid #e2e8f0; border-radius:20px; padding:clamp(20px,3vw,32px); min-height:300px; box-shadow:0 4px 32px rgba(15,23,42,0.07); display:flex; flex-direction:column; gap:12px; transition:opacity 0.28s ease; }
  .am-hiw-panel.fading { opacity:0; }

  /* ─── Progress bar for active step ─── */
  .am-hiw-progress { height:2px; background:#e2e8f0; border-radius:2px; overflow:hidden; margin-top:4px; }
  .am-hiw-progress-fill { height:100%; background:#2563eb; border-radius:2px; animation:fillBar 3.6s linear; }
  @keyframes fillBar { from{width:0%} to{width:100%} }

  /* ─── What you get ─── */
  .am-wyg-2col { display:grid; grid-template-columns:1fr 1fr; gap:clamp(40px,6vw,80px); align-items:start; }
  @media(max-width:680px){ .am-wyg-2col{grid-template-columns:1fr} }

  /* ─── Apple scroll-reveal ─── */
  .am-reveal { opacity:0; transform:translateY(24px); transition:opacity 0.65s cubic-bezier(0.25,0.46,0.45,0.94),transform 0.65s cubic-bezier(0.25,0.46,0.45,0.94); }
  .am-reveal.visible { opacity:1; transform:translateY(0); }
  .am-reveal-d1 { transition-delay:0.08s; }
  .am-reveal-d2 { transition-delay:0.18s; }
  .am-reveal-d3 { transition-delay:0.28s; }
  .am-reveal-d4 { transition-delay:0.38s; }

  /* ─── Apple eyebrow label ─── */
  .am-eyebrow { font-size:0.68rem; font-weight:700; letter-spacing:0.09em; text-transform:uppercase; color:#6366f1; margin-bottom:14px; display:block; text-align:center; }

  /* ─── Apple How it works step rows ─── */
  .am-steps-apple { border-bottom:1px solid #e8e8ed; }
  .am-step-apple { display:flex; align-items:flex-start; gap:clamp(20px,4vw,52px); padding:clamp(26px,4vw,52px) 0; border-top:1px solid #e8e8ed; }
  .am-step-num-big { font-size:clamp(2.6rem,5vw,4rem); font-weight:900; color:#d1d5db; line-height:1; flex-shrink:0; width:clamp(56px,7vw,84px); letter-spacing:-0.04em; }
  .am-step-icon-wrap { width:44px; height:44px; border-radius:13px; display:flex; align-items:center; justify-content:center; font-size:1.3rem; flex-shrink:0; margin-top:4px; }
  .am-step-text h3 { font-size:clamp(1.05rem,1.8vw,1.3rem); font-weight:800; color:#1d1d1f; margin:0 0 8px; letter-spacing:-0.025em; }
  .am-step-text p  { font-size:clamp(0.84rem,1.1vw,0.96rem); color:#6e6e73; line-height:1.72; margin:0; }

  /* ─── Apple module strip (borderless rows) ─── */
  .am-modules-apple { }
  .am-module-apple { display:flex; gap:clamp(16px,3vw,32px); padding:clamp(28px,4vw,52px) 0; border-top:1px solid #e8e8ed; align-items:flex-start; }
  .am-module-apple:last-child { border-bottom:1px solid #e8e8ed; }
  .am-module-icon-wrap { width:54px; height:54px; border-radius:16px; display:flex; align-items:center; justify-content:center; font-size:1.5rem; flex-shrink:0; }
  .am-module-body h3 { font-size:clamp(1.05rem,1.8vw,1.25rem); font-weight:800; color:#1d1d1f; margin:0 0 10px; letter-spacing:-0.02em; }
  .am-module-body p  { font-size:clamp(0.83rem,1vw,0.93rem); color:#6e6e73; line-height:1.72; margin:0 0 14px; }
  @media(max-width:640px){ .am-module-apple { flex-direction:column; } }

  /* ─── Dark mode ─── */
  [data-theme="dark"] .am-landing { background:#0f172a; color:#f1f5f9; }
  [data-theme="dark"] .am-landing nav { background:rgba(15,23,42,0.94)!important; border-color:rgba(255,255,255,0.07)!important; }
  [data-theme="dark"] .am-landing nav span { color:#f1f5f9!important; }
  [data-theme="dark"] .am-landing nav button:not([style*="background:#2563eb"]):not([style*="background: #2563eb"]):not([style*="background:linear"]):not([style*="background: linear"]) { color:#94a3b8!important; }
  [data-theme="dark"] .am-hero-s   { background:#0f172a!important; }
  [data-theme="dark"] .am-stats-s  { background:#0f172a!important; border-color:#334155!important; }
  [data-theme="dark"] .am-social-s { background:#0f172a!important; border-color:#334155!important; }
  [data-theme="dark"] .am-section  { background:#0f172a!important; }
  [data-theme="dark"] .am-ticker-item { border-color:#334155!important; }
  [data-theme="dark"] .am-landing h1 { color:#f1f5f9!important; }
  [data-theme="dark"] .am-landing h2 { color:#f1f5f9!important; }
  [data-theme="dark"] .am-landing p  { color:#94a3b8!important; }
  [data-theme="dark"] .am-hiw-step:not(.active) { background:transparent!important; }
  [data-theme="dark"] .am-hiw-step:hover { background:#1e293b!important; }
  [data-theme="dark"] .am-hiw-step.active { background:rgba(37,99,235,0.18)!important; }
  [data-theme="dark"] .am-hiw-step:not(.active) .am-hiw-num { background:#1e293b!important; color:#64748b!important; }
  [data-theme="dark"] .am-hiw-step.active h3 { color:#f1f5f9!important; }
  [data-theme="dark"] .am-hiw-step p { color:#64748b!important; }
  [data-theme="dark"] .am-hiw-panel { background:#1e293b!important; border-color:#334155!important; }
  [data-theme="dark"] .am-hiw-progress { background:#334155!important; }
  [data-theme="dark"] .am-wyg-bento > div { background:#1e293b!important; border-color:#334155!important; }
  [data-theme="dark"] .am-price-card { border-color:#334155!important; }
  [data-theme="dark"] .am-price-card:not([style*="#131929"]):not([style*="#1a1040"]):not([style*="linear-gradient(160deg"]) { background:#1e293b!important; }
  [data-theme="dark"] .am-theme-toggle { background:#1e293b!important; border-color:#334155!important; color:#94a3b8!important; }
  [data-theme="dark"] .am-hamburger-root button { background:#1e293b!important; border-color:#334155!important; }
  [data-theme="dark"] .am-hamburger-root button span { background:#94a3b8!important; }
  [data-theme="dark"] .am-hamburger-root > div > div { background:#1e293b!important; border-color:#334155!important; }
  [data-theme="dark"] .am-hamburger-root > div > div button { background:transparent!important; color:#94a3b8!important; }
`;






/* ─── design tokens ─── */

const C = {

  bg:      '#ffffff',

  bgMid:   '#f8fafc',

  white:   '#ffffff',

  muted:   '#64748b',

  border:  '#e2e8f0',

  indigo:  '#4f46e5',

  indigoL: '#6366f1',

  indigoXL:'#eef2ff',

  navy:    '#0f172a',

  ink:     '#1e293b',

  green:   '#10b981',

};





/* ─── reveal on scroll ─── */

const useReveal = (threshold = 0.12) => {

  const ref = useRef(null);

  const [vis, setVis] = useState(false);

  useEffect(() => {

    const el = ref.current; if (!el) return;

    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVis(true); }, { threshold });

    obs.observe(el);

    return () => obs.disconnect();

  }, [threshold]);

  return [ref, vis];

};





/* ─── animated counter ─── */

const useCounter = (target, duration = 1400) => {

  const [val, setVal] = useState(0);

  const started = useRef(false);

  const start = useCallback(() => {

    if (started.current) return;

    started.current = true;

    const s = Date.now();

    const tick = () => {

      const p = Math.min((Date.now() - s) / duration, 1);

      setVal(Math.round(target * (p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2)));

      if (p < 1) requestAnimationFrame(tick);

    };

    requestAnimationFrame(tick);

  }, [target, duration]);

  return [val, start];

};
















/* ════════════════════════════════════════════

   DEMO MODULES (used by app page)

════════════════════════════════════════════ */

const DEMO_MODULES = {

  ortho: {

    icon: '🦴', label: 'Orthopaedic',

    accent: '#4f46e5', accentBg: '#eef2ff',

    region: 'Shoulder',

    chips: [

      { label: 'Positive Hawkins-Kennedy' },

      { label: "Positive Neer's Sign" },

      { label: 'Reduced IR (40°)' },

      { label: 'MMT Grade 4 — Supraspinatus' },

      { label: 'Painful Arc 70–120°' },

    ],

    result: {

      primary: 'Rotator Cuff Impingement Syndrome',

      phase: 'Subacute', phaseColor: '#d97706', phaseBg: '#fffbeb',

      goals: ['Pain-free arc by week 3', 'Full IR ROM by week 8', 'Return to overhead sport 12 wks'],

      plan: ['Phase 1: Scapular stabilisation + pendulum', 'Phase 2: RTC strengthening — band ER/IR 3×15', 'Phase 3: Overhead loading progression'],

      prognosis: 'Good — expect 6–10 wks with adherent program',

      measures: ['DASH', 'NPRS', 'Shoulder ROM goniometry'],

    },

  },

  neuro: {

    icon: '🧠', label: 'Neurological',

    accent: '#7c3aed', accentBg: '#f5f3ff',

    region: 'Hemiplegia (Left CVA)',

    chips: [

      { label: 'UMN Pattern — Left side' },

      { label: 'Spasticity Grade 2 (MAS)' },

      { label: 'MMT Grade 3 — Hip flexors' },

      { label: 'Coordination deficit — FNT' },

      { label: 'Balance: Sit — Impaired' },

    ],

    result: {

      primary: 'Post-Stroke Left Hemiplegia',

      phase: 'Subacute Rehab', phaseColor: '#d97706', phaseBg: '#fffbeb',

      goals: ['Independent sitting balance — 4 wks', 'Assisted gait 10m — 6 wks', 'Modified ADL independence — 3 mo'],

      plan: ['Task-specific training: sit-to-stand', 'Spasticity management: positioning + stretch', 'FES or mirror therapy for upper limb'],

      prognosis: 'Moderate — neuroplasticity potential within 6-month window',

      measures: ['Barthel Index', 'Berg Balance Scale', 'FIM Motor Score'],

    },

  },

  cardio: {

    icon: '🫁', label: 'Cardiopulmonary',

    accent: '#0891b2', accentBg: '#ecfeff',

    region: 'Post-op CABG — Day 3',

    chips: [

      { label: 'Reduced chest expansion bilat.' },

      { label: 'Weak cough — sputum present' },

      { label: 'SpO₂ 93% on 3L NC' },

      { label: 'Borg 4/10 — step-up test' },

      { label: 'HR 102 at rest' },

    ],

    result: {

      primary: 'Post-Surgical Atelectasis + Reduced Exercise Tolerance',

      phase: 'Acute', phaseColor: '#dc2626', phaseBg: '#fef2f2',

      goals: ['Independent ACBT by session 2', 'Walk 20m corridor on day 4', 'SpO₂ stable ≥94% on 2L'],

      plan: ['Incentive spirometry q1h while awake', 'ACBT with huffing × 4 sessions/day', 'Graded mobilisation: bedside → corridor'],

      prognosis: 'Good — expected discharge readiness day 5–6 with adherence',

      measures: ['6MWT', 'Borg RPE', 'MRC Dyspnoea Scale'],

    },

  },

};



// eslint-disable-next-line no-unused-vars
const LiveDemo = () => {

  const [activeTab, setActiveTab] = useState('ortho');

  const [selected, setSelected] = useState([]);

  const [stage, setStage] = useState('input');

  const [resultVisible, setResultVisible] = useState(false);

  const mod = DEMO_MODULES[activeTab];



  const switchTab = (tab) => { setActiveTab(tab); setSelected([]); setStage('input'); setResultVisible(false); };

  const toggleChip = (label) => { if (stage !== 'input') return; setSelected(s => s.includes(label) ? s.filter(x => x !== label) : [...s, label]); };

  const runAI = () => {

    if (selected.length === 0) return;

    setStage('loading');

    setTimeout(() => { setStage('result'); setTimeout(() => setResultVisible(true), 80); }, 1800);

  };

  const reset = () => { setSelected([]); setStage('input'); setResultVisible(false); };



  return (

    <div style={{ background: '#ffffff', borderRadius: 20, border: '1px solid #e2e8f0', overflow: 'hidden', boxShadow: '0 24px 64px rgba(15,23,42,0.10)', maxWidth: 660, width: '100%' }}>

      <div style={{ background: '#f8fafc', padding: '10px 16px', display: 'flex', alignItems: 'center', gap: 8, borderBottom: '1px solid #e2e8f0' }}>

        {['#ff5f57', '#febc2e', '#28c840'].map(c => <div key={c} style={{ width: 10, height: 10, borderRadius: '50%', background: c }} />)}

        <div style={{ flex: 1, height: 7, background: '#e2e8f0', borderRadius: 4, marginLeft: 8 }} />

        <div style={{ fontSize: '0.65rem', color: '#94a3b8', fontWeight: 600 }}>AssessMonk — AI Assessment</div>

      </div>

      <div style={{ display: 'flex', gap: 4, padding: '10px 14px', background: '#f1f5f9', borderBottom: '1px solid #e2e8f0' }}>

        {Object.entries(DEMO_MODULES).map(([key, m]) => (

          <button key={key} className="am-tab" onClick={() => switchTab(key)} style={{

            display: 'flex', alignItems: 'center', gap: 6, padding: '6px 14px', borderRadius: 8, border: 'none', cursor: 'pointer', transition: 'all 0.15s',

            background: activeTab === key ? `${m.accent}15` : 'transparent',

            color: activeTab === key ? m.accent : '#64748b',

            fontWeight: activeTab === key ? 800 : 600, fontSize: '0.78rem',

            outline: activeTab === key ? `1px solid ${m.accent}33` : 'none',

          }}>

            <span>{m.icon}</span>{m.label}

          </button>

        ))}

      </div>

      <div style={{ padding: '16px 18px', minHeight: 320 }}>

        {stage === 'input' && (

          <div style={{ animation: 'fadeIn 0.3s' }}>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>

              <div>

                <div style={{ fontSize: '0.65rem', fontWeight: 800, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Region</div>

                <div style={{ fontSize: '0.85rem', fontWeight: 800, color: '#1e293b', marginTop: 2 }}>{mod.region}</div>

              </div>

              <span style={{ fontSize: '0.65rem', fontWeight: 700, padding: '3px 9px', borderRadius: 99, background: `${mod.accent}12`, color: mod.accent }}>

                {selected.length}/{mod.chips.length} findings selected

              </span>

            </div>

            <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#94a3b8', marginBottom: 8 }}>Select clinical findings:</div>

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 7, marginBottom: 16 }}>

              {mod.chips.map(chip => {

                const active = selected.includes(chip.label);

                return (

                  <button key={chip.label} onClick={() => toggleChip(chip.label)} className="am-chip-hover" style={{

                    fontSize: '0.72rem', fontWeight: 600, padding: '5px 11px', borderRadius: 99, cursor: 'pointer',

                    border: `1px solid ${active ? mod.accent : '#e2e8f0'}`,

                    background: active ? `${mod.accent}12` : '#f8fafc',

                    color: active ? mod.accent : '#64748b', transition: 'all 0.15s',

                  }}>

                    {active ? '✓ ' : ''}{chip.label}

                  </button>

                );

              })}

            </div>

            <button onClick={runAI} disabled={selected.length === 0} style={{

              width: '100%', padding: '11px', borderRadius: 10, fontWeight: 800, fontSize: '0.85rem', border: 'none',

              cursor: selected.length > 0 ? 'pointer' : 'not-allowed', transition: 'all 0.2s',

              background: selected.length > 0 ? `linear-gradient(135deg, ${mod.accent}, ${C.indigoL})` : '#f1f5f9',

              color: selected.length > 0 ? '#fff' : '#94a3b8',

              boxShadow: selected.length > 0 ? `0 8px 20px ${mod.accent}33` : 'none',

            }}>

              {selected.length > 0 ? `Analyse ${selected.length} findings with AI` : 'Select findings above to enable AI'}

            </button>

          </div>

        )}

        {stage === 'loading' && (

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 200, gap: 20, animation: 'fadeIn 0.3s' }}>

            <div style={{ width: 48, height: 48, border: `3px solid ${mod.accent}22`, borderTop: `3px solid ${mod.accent}`, borderRadius: '50%', animation: 'spin 0.9s linear infinite' }} />

            <div style={{ fontSize: '0.85rem', fontWeight: 700, color: '#64748b', textAlign: 'center' }}>Analysing {selected.length} clinical findings…</div>

          </div>

        )}

        {stage === 'result' && (

          <div style={{ opacity: resultVisible ? 1 : 0, transform: resultVisible ? 'none' : 'translateY(12px)', transition: 'all 0.4s' }}>

            <div style={{ background: '#eef2ff', borderRadius: 12, padding: '12px 14px', marginBottom: 10, border: '1px solid #c7d2fe' }}>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>

                <span style={{ fontSize: '0.6rem', fontWeight: 800, color: '#4f46e5', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Primary Impression</span>

                <span style={{ fontSize: '0.62rem', fontWeight: 800, padding: '2px 8px', borderRadius: 99, background: mod.result.phaseBg, color: mod.result.phaseColor }}>{mod.result.phase}</span>

              </div>

              <div style={{ fontSize: '0.88rem', fontWeight: 800, color: '#1e293b' }}>{mod.result.primary}</div>

              <div style={{ fontSize: '0.72rem', color: '#64748b', marginTop: 5, fontStyle: 'italic' }}>{mod.result.prognosis}</div>

            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 10 }}>

              <div style={{ background: '#f0fdf4', borderRadius: 10, padding: '10px 12px', border: '1px solid #bbf7d0' }}>

                <div style={{ fontSize: '0.6rem', fontWeight: 800, color: '#059669', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 6 }}>Treatment Plan</div>

                {mod.result.plan.map((p, i) => <div key={i} style={{ fontSize: '0.68rem', color: '#166534', lineHeight: 1.5, marginBottom: 3 }}>• {p}</div>)}

              </div>

              <div style={{ background: '#f5f3ff', borderRadius: 10, padding: '10px 12px', border: '1px solid #ddd6fe' }}>

                <div style={{ fontSize: '0.6rem', fontWeight: 800, color: '#7c3aed', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 6 }}>SMART Goals</div>

                {mod.result.goals.map((g, i) => <div key={i} style={{ fontSize: '0.68rem', color: '#5b21b6', lineHeight: 1.5, marginBottom: 3 }}>• {g}</div>)}

              </div>

            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

              <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap' }}>

                {mod.result.measures.map(m => <span key={m} style={{ fontSize: '0.6rem', fontWeight: 700, padding: '3px 8px', borderRadius: 99, background: '#f8fafc', color: '#64748b', border: '1px solid #e2e8f0' }}>{m}</span>)}

              </div>

              <button onClick={reset} style={{ fontSize: '0.68rem', fontWeight: 700, padding: '5px 12px', borderRadius: 8, border: '1px solid #e2e8f0', background: 'transparent', color: '#64748b', cursor: 'pointer' }}>↺ Reset</button>

            </div>

          </div>

        )}

      </div>

    </div>

  );

};





/* ════════════════════════════════════════════

   BENTO CARD

════════════════════════════════════════════ */

// eslint-disable-next-line no-unused-vars
const BentoCard = ({ style = {}, className = '', children, delay = 0 }) => {

  const [ref, vis] = useReveal();

  return (

    <div ref={ref} className={`am-bento ${className}`} style={{

      background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: 20,

      padding: '28px 26px', transition: 'all 0.3s', cursor: 'default',

      boxShadow: '0 2px 12px rgba(15,23,42,0.06)',

      opacity: vis ? 1 : 0, transform: vis ? 'none' : 'translateY(24px)',

      animation: vis ? `fadeUp 0.55s ${delay}ms both` : 'none',

      ...style,

    }}>

      {children}

    </div>

  );

};





/* ── animated counter ── */
// eslint-disable-next-line no-unused-vars
const CounterCard = ({ target, suffix, label, sub }) => {

  const [ref, vis] = useReveal(0.3);

  const [val, start] = useCounter(target);

  useEffect(() => { if (vis) start(); }, [vis, start]);

  return (

    <div ref={ref} style={{ textAlign: 'center' }}>

      <div style={{ fontSize: 'clamp(2rem,4vw,3rem)', fontWeight: 900, color: C.navy, letterSpacing: '-0.03em', lineHeight: 1 }}>

        {val.toLocaleString()}{suffix}

      </div>

      <div style={{ fontSize: '0.88rem', fontWeight: 700, color: '#64748b', marginTop: 6 }}>{label}</div>

      {sub && <div style={{ fontSize: '0.72rem', color: '#94a3b8', marginTop: 3 }}>{sub}</div>}

    </div>

  );

};





/* ── feature row ── */
// eslint-disable-next-line no-unused-vars
const FeatureRow = ({ icon, title, body, delay }) => {

  const [ref, vis] = useReveal();

  return (

    <div ref={ref} className="am-feature" style={{

      display: 'flex', gap: 16, alignItems: 'flex-start', padding: '20px 0', borderBottom: '1px solid #e2e8f0',

      opacity: vis ? 1 : 0, transform: vis ? 'none' : 'translateX(-20px)',

      transition: `opacity 0.5s ${delay}ms, transform 0.5s ${delay}ms`,

    }}>

      <div className="am-feature-icon" style={{ fontSize: '1.5rem', width: 44, height: 44, borderRadius: 12, background: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, transition: 'transform 0.25s' }}>{icon}</div>

      <div>

        <div style={{ fontWeight: 800, fontSize: '0.95rem', color: C.navy, marginBottom: 5 }}>{title}</div>

        <div style={{ fontSize: '0.85rem', color: '#64748b', lineHeight: 1.7 }}>{body}</div>

      </div>

    </div>

  );

};





/* ════════════════════════════════════════════

   NAVBAR

════════════════════════════════════════════ */

const NavBar = ({ onSignIn, onPricing }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { isDark, toggleTheme } = useTheme();

  useEffect(() => {
    if (!menuOpen) return;
    const close = (e) => { if (!e.target.closest('.am-hamburger-root')) setMenuOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [menuOpen]);

  return (
    <nav style={{
      flexShrink: 0, height: 54, zIndex: 200,
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '0 clamp(16px,4vw,36px)',
      borderBottom: '1px solid rgba(226,232,240,0.6)',
      background: 'rgba(255,255,255,0.75)', backdropFilter: 'blur(14px)',
    }}>
      {/* Brand */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
        <img src="/logo192.png" alt="AssessMonk" style={{ width: 30, height: 30, borderRadius: 8, objectFit: 'contain', flexShrink: 0 }} />
        <span style={{ fontWeight: 900, fontSize: '1.02rem', color: '#0f172a', letterSpacing: '-0.02em' }}>AssessMonk</span>
      </div>

      {/* Desktop nav */}
      <div className="am-nav-desktop">
        <button className="am-theme-toggle" onClick={toggleTheme} title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
          style={{ background: '#f8faff', border: '1px solid #e2e8f0', borderRadius: 8, width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: '1rem', transition: 'all 0.15s', flexShrink: 0 }}>
          {isDark ? '☀️' : '🌙'}
        </button>
        <button onClick={onSignIn} style={{ background: C.indigo, border: 'none', padding: '8px 18px', fontSize: '0.85rem', fontWeight: 700, color: '#fff', cursor: 'pointer', borderRadius: 9, display: 'flex', alignItems: 'center', gap: 6, transition: 'opacity 0.15s' }}
          onMouseEnter={e => e.currentTarget.style.opacity = '0.88'} onMouseLeave={e => e.currentTarget.style.opacity = '1'}>
          Sign in
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
        </button>
      </div>

      {/* Mobile hamburger */}
      <div className="am-hamburger-root am-nav-mobile" style={{ position: 'relative' }}>
        <button onClick={() => setMenuOpen(v => !v)} style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 9, width: 40, height: 40, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 4, cursor: 'pointer' }} aria-label="Menu">
          {[0,1,2].map(i => <span key={i} style={{ display: 'block', width: 16, height: 2, background: '#334155', borderRadius: 2 }} />)}
        </button>
        {menuOpen && (
          <div style={{ position: 'absolute', top: 48, right: 0, background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', boxShadow: '0 8px 24px rgba(0,0,0,0.12)', padding: 8, minWidth: 160, zIndex: 300, animation: 'fadeIn 0.12s ease-out' }}>
            <button onClick={() => { onSignIn(); setMenuOpen(false); }} style={{ display: 'block', width: '100%', textAlign: 'left', padding: '10px 14px', borderRadius: 8, border: 'none', background: C.indigo, fontSize: '0.88rem', fontWeight: 700, color: '#fff', cursor: 'pointer', marginTop: 4 }}>Sign in</button>
            <button onClick={toggleTheme} style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%', padding: '10px 14px', borderRadius: 8, border: 'none', background: 'none', fontSize: '0.88rem', fontWeight: 600, color: '#334155', cursor: 'pointer', marginTop: 4 }}>
              {isDark ? '☀️' : '🌙'} {isDark ? 'Light mode' : 'Dark mode'}
            </button>
            <div style={{ height: 1, background: '#f1f5f9', margin: '8px 0' }} />
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 10px', padding: '2px 6px 4px' }}>
              {[['Privacy','/privacy'],['Terms','/terms'],['Contact','/contact'],['Refund','/refund'],['Disclaimer','/disclaimer']].map(([label,to]) => (
                <Link key={to} to={to} onClick={() => setMenuOpen(false)} style={{ fontSize: '0.7rem', color: '#94a3b8', textDecoration: 'none', fontWeight: 500 }}>{label}</Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};





/* ════════════════════════════════════════════

   MAIN LANDING PAGE

════════════════════════════════════════════ */

export default function LandingPage() {
  const { isDark } = useTheme();
  const navigate = useNavigate();

  useEffect(() => { window.scrollTo(0, 0); }, []);

  // Capture referral code from URL and persist it for post-login application
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (ref) {
      localStorage.setItem('pending_ref', ref.toUpperCase().trim().slice(0, 15));
    }
  }, []);

  const isLoggedIn = (() => {
    try {
      const token = localStorage.getItem('auth_token');
      if (!token) return false;
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.exp * 1000 > Date.now();
    } catch { return false; }
  })();

  const handleOneTapSuccess = async (credentialResponse) => {
    try {
      const pendingRefCode = localStorage.getItem('pending_ref') || undefined;
      const res  = await fetch(`${API_BASE}/api/auth/google`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ credential: credentialResponse.credential, pendingRefCode }),
      });
      const data = await res.json();
      if (data.token) {
        localStorage.setItem('auth_token', data.token);
        localStorage.setItem('auth_name',  data.name);
        localStorage.setItem('auth_email', data.email);
        localStorage.removeItem('pending_ref');
        navigate('/home');
      }
    } catch { /* silent — no button fallback on landing, user can click Sign in */ }
  };

  useGoogleOneTapLogin({
    onSuccess:             handleOneTapSuccess,
    onError:               () => { /* silent */ },
    disabled:              isLoggedIn,
    auto_select:           false,
    cancel_on_tap_outside: true,
    itp_support:           true,
  });

  const [showAuth, setShowAuth] = useState(false);
  const [showPricing, setShowPricing] = useState(false);
  const [assessmentCount, setAssessmentCount] = useState(0);
  const counterRef = useRef(null);
  const [activeStep, setActiveStep] = useState(0);
  const [panelFading, setPanelFading] = useState(false);

  useEffect(() => {
    const el = counterRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        const target = 1000;
        const duration = 1800;
        const steps = 60;
        const increment = target / steps;
        let current = 0;
        const interval = setInterval(() => {
          current += increment;
          if (current >= target) {
            setAssessmentCount(target);
            clearInterval(interval);
          } else {
            setAssessmentCount(Math.floor(current));
          }
        }, duration / steps);
      },
      { threshold: 0.4 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const id = setInterval(() => {
      setPanelFading(true);
      setTimeout(() => { setActiveStep(s => (s + 1) % 4); setPanelFading(false); }, 280);
    }, 3600);
    return () => clearInterval(id);
  }, []);


  useEffect(() => {
    if (!showAuth) return;
    const onKey = (e) => { if (e.key === 'Escape') setShowAuth(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [showAuth]);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); } }),
      { threshold: 0.1 }
    );
    document.querySelectorAll('.am-reveal').forEach(el => obs.observe(el));
    return () => obs.disconnect();
  }, []);






  const GRAIN = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='300'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`;
  const grainOverlay = { position: 'absolute', inset: 0, pointerEvents: 'none', zIndex: 1, opacity: 0.045, backgroundImage: GRAIN, backgroundSize: '180px' };

  const googleSvg = (
    <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
    </svg>
  );

  return (

    <div className="am-landing" style={{ minHeight: '100vh', overflowX: 'hidden', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', color: isDark ? '#f1f5f9' : '#0f172a', background: isDark ? '#0f172a' : '#fff' }}>

      <style>{STYLES}</style>

      <div style={{ position: 'sticky', top: 0, zIndex: 200 }}>
        <NavBar onSignIn={() => setShowAuth(true)} onPricing={() => setShowPricing(true)} />
      </div>

      {/* ── Auth modal ── */}
      {showAuth && (
        <div
          onClick={() => setShowAuth(false)}
          style={{
            position: 'fixed', inset: 0, zIndex: 9999,
            background: 'rgba(15,23,42,0.55)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: 20,
            backdropFilter: 'blur(4px)',
            animation: 'fadeIn 0.15s ease-out',
          }}
        >
          <div onClick={e => e.stopPropagation()}>
            <AuthCard onClose={() => setShowAuth(false)} />
          </div>
        </div>
      )}

      {/* ── Pricing modal ── */}
      {showPricing && (
        <div
          onClick={() => setShowPricing(false)}
          style={{
            position: 'fixed', inset: 0, zIndex: 9998,
            background: 'rgba(15,23,42,0.6)',
            display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
            overflowY: 'auto', padding: '60px 16px 40px',
            backdropFilter: 'blur(4px)',
            animation: 'fadeIn 0.15s ease-out',
          }}
        >
          <div onClick={e => e.stopPropagation()} style={{ width: '100%', maxWidth: 1060, position: 'relative' }}>
            {/* Close button */}
            <button
              onClick={() => setShowPricing(false)}
              style={{
                position: 'absolute', top: -44, right: 0,
                background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.25)',
                borderRadius: 10, width: 36, height: 36, color: '#fff', fontSize: '1.1rem',
                cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}
            >✕</button>

            <div style={{ background: '#ffffff', borderRadius: 24, padding: 'clamp(28px,5vw,48px)', position: 'relative', overflow: 'hidden' }}>
              <div style={{ position: 'absolute', top: '30%', left: '50%', transform: 'translateX(-50%)', width: 700, height: 300, background: 'radial-gradient(ellipse, rgba(79,70,229,0.12) 0%, transparent 70%)', pointerEvents: 'none' }} />

              {/* Header */}
              <div style={{ textAlign: 'center', marginBottom: 36, position: 'relative' }}>
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: 'rgba(79,70,229,0.1)', border: '1px solid rgba(99,102,241,0.3)', borderRadius: 99, padding: '5px 14px', fontSize: '0.72rem', fontWeight: 700, color: '#4f46e5', marginBottom: 16, letterSpacing: '0.04em' }}>
                  <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#4f46e5', display: 'inline-block' }} />
                  Simple, transparent pricing
                </div>
                <h2 style={{ fontSize: 'clamp(1.6rem,3.5vw,2.4rem)', fontWeight: 900, lineHeight: 1.1, letterSpacing: '-0.03em', margin: '0 0 12px', color: '#0f172a' }}>
                  Start free. Upgrade when you're ready.
                </h2>
                <p style={{ color: '#64748b', fontSize: '0.95rem', lineHeight: 1.7, maxWidth: 460, margin: '0 auto' }}>
                  Every plan includes the full clinical reasoning framework. No hidden costs. No feature tricks.
                </p>
              </div>

              {/* Cards */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 14 }}>
                {[
                  {
                    name: 'Free', sub: 'Always free',
                    price: '₹0', note: 'No card required',
                    recommended: false, accent: '#34d399',
                    desc: '3 free assessments — form, AI, refine, chat, and PDF. After that, forms are locked until you pay.',
                    features: ['3 free assessments', 'All 3 clinical modules', 'No card required'],
                    btnLabel: 'Get started free', btnStyle: 'light',
                  },
                  {
                    name: 'Pay per use', sub: 'No subscription needed',
                    price: '₹19', note: 'per diagnosis session',
                    recommended: false, accent: '#6366f1',
                    desc: 'Pay only when you need AI. Each ₹19 unlocks diagnosis, refine, chat & PDF for one session.',
                    features: ['AI diagnosis & treatment plan', 'Refine & chat for that session', 'PDF download', 'No expiry'],
                    btnLabel: 'Get started free', btnStyle: 'light',
                  },
                  {
                    name: 'Student', sub: 'For learners · Yearly',
                    price: '₹1,299', note: 'per year · billed annually',
                    recommended: false, accent: '#6366f1',
                    desc: 'Unlimited AI diagnoses, full history sync, and PDF export all year.',
                    features: ['Unlimited AI diagnoses', 'PDF reports', 'History synced', 'All 3 modules'],
                    btnLabel: 'Get started free', btnStyle: 'indigo',
                  },
                  {
                    name: 'Clinician', sub: 'Recommended · Yearly',
                    price: '₹1,999', note: 'per year · billed annually',
                    recommended: true, accent: '#a78bfa',
                    desc: 'Everything in Student plus deeper clinical reasoning for sharper diagnoses.',
                    features: ['Deeper clinical reasoning', 'Everything in Student', 'Unlimited history', 'PDF export'],
                    btnLabel: 'Get started free', btnStyle: 'purple',
                  },
                ].map((plan) => (
                  <div key={plan.name} className="am-price-card" style={{
                    background: plan.recommended ? 'linear-gradient(160deg, #1e1b4b 0%, #1a1040 100%)' : '#131929',
                    border: plan.recommended ? '1px solid rgba(167,139,250,0.45)' : '1px solid rgba(255,255,255,0.07)',
                    borderRadius: 18, padding: '24px 20px', position: 'relative',
                    boxShadow: plan.recommended ? '0 0 0 1px rgba(167,139,250,0.2), 0 16px 40px rgba(0,0,0,0.4)' : '0 8px 28px rgba(0,0,0,0.3)',
                  }}>
                    {plan.recommended && (
                      <div style={{ position: 'absolute', top: -11, left: '50%', transform: 'translateX(-50%)', background: 'linear-gradient(135deg, #7c3aed, #6366f1)', borderRadius: 99, padding: '3px 12px', fontSize: '0.62rem', fontWeight: 800, color: '#fff', whiteSpace: 'nowrap' }}>
                        Recommended
                      </div>
                    )}
                    <div style={{ marginBottom: 16 }}>
                      <div style={{ fontSize: '1.15rem', fontWeight: 900, color: '#f1f5f9', marginBottom: 3 }}>{plan.name}</div>
                      <div style={{ fontSize: '0.72rem', color: plan.recommended ? '#a78bfa' : '#64748b', fontWeight: 600 }}>{plan.sub}</div>
                    </div>
                    <div style={{ marginBottom: 16, paddingBottom: 16, borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
                      <div style={{ fontSize: 'clamp(1.7rem,3vw,2.2rem)', fontWeight: 900, color: '#f8fafc', lineHeight: 1, marginBottom: 4 }}>{plan.price}</div>
                      <div style={{ fontSize: '0.68rem', color: '#475569', fontWeight: 600 }}>{plan.note}</div>
                    </div>
                    <div style={{ fontSize: '0.78rem', color: '#94a3b8', lineHeight: 1.6, marginBottom: 18 }}>{plan.desc}</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 22 }}>
                      {plan.features.map(f => (
                        <div key={f} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.78rem', color: '#cbd5e1', fontWeight: 600 }}>
                          <span style={{ fontSize: '0.7rem', color: plan.accent, flexShrink: 0, fontWeight: 900 }}>✓</span>
                          {f}
                        </div>
                      ))}
                    </div>
                    <button
                      className="am-price-btn"
                      onClick={() => { setShowPricing(false); navigate('/app'); }}
                      style={{
                        width: '100%', padding: '12px', borderRadius: 11, fontWeight: 800, fontSize: '0.85rem',
                        cursor: 'pointer', border: 'none', transition: 'all 0.18s',
                        background: plan.btnStyle === 'light'  ? '#f1f5f9'
                                  : plan.btnStyle === 'indigo' ? 'linear-gradient(135deg, #4f46e5, #6366f1)'
                                  : plan.btnStyle === 'purple' ? 'linear-gradient(135deg, #7c3aed, #a78bfa)'
                                  : 'linear-gradient(135deg, #059669, #34d399)',
                        color: plan.btnStyle === 'light' ? '#0f172a' : '#ffffff',
                      }}
                    >
                      {plan.btnLabel}
                    </button>
                  </div>
                ))}
              </div>

              <div style={{ textAlign: 'center', marginTop: 24, fontSize: '0.73rem', color: '#64748b' }}>
                Yearly plans billed once — no auto-renewal surprises
              </div>
            </div>
          </div>
        </div>
      )}





      {/* ═══ HERO ═══ */}
      <section className="am-hero-s" style={{ background: '#fff', padding: 'clamp(16px,2.5vw,32px) clamp(20px,5vw,40px) clamp(28px,4vw,48px)' }}>
        <div className="am-container">
          <div className="am-hero-grid" style={{ alignItems: 'center', gap: 'clamp(32px,5vw,64px)' }}>
            {/* Left */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 'clamp(18px,2.5vw,24px)' }}>
              <div>
                <h1 style={{ fontSize: 'clamp(2.4rem,5vw,4rem)', fontWeight: 900, lineHeight: 1.05, letterSpacing: '-0.04em', margin: '0 0 4px', color: '#0f172a' }}>Physiotherapy</h1>
                <h1 style={{ fontSize: 'clamp(2.4rem,5vw,4rem)', fontWeight: 900, lineHeight: 1.05, letterSpacing: '-0.04em', margin: 0, background: 'linear-gradient(135deg,#2563eb 0%,#4f46e5 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>Assessments, Powered by AI.</h1>
              </div>
              <p style={{ fontSize: 'clamp(0.9rem,1.4vw,1.05rem)', color: '#64748b', lineHeight: 1.75, margin: 0, maxWidth: 460 }}>
                <span style={{ fontWeight: 800, color: '#0f172a' }}>Structured subjective and objective assessments</span> for Musculoskeletal, Neuro &amp; Cardio. Get an AI diagnosis, refine it, chat with it, and export a clean PDF — in minutes.
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 380 }}>
                <div role="button" tabIndex={0} onClick={() => setShowAuth(true)} onKeyDown={e => e.key === 'Enter' && setShowAuth(true)}
                  style={{ background: '#2563eb', borderRadius: 12, border: 'none', padding: '15px 24px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, cursor: 'pointer', transition: 'background 0.18s,transform 0.18s', boxShadow: '0 4px 20px rgba(37,99,235,0.35)' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#1d4ed8'}
                  onMouseLeave={e => e.currentTarget.style.background = '#2563eb'}
                >
                  <div style={{ background: '#fff', borderRadius: 7, width: 26, height: 26, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{googleSvg}</div>
                  <span style={{ fontSize: '0.97rem', fontWeight: 700, color: '#fff' }}>Sign in with Google</span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.8 }}><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                </div>
                <p style={{ margin: 0, textAlign: 'center', fontSize: '0.7rem', color: '#94a3b8', fontWeight: 500 }}>3 free assessments &nbsp;·&nbsp; ₹19/assessment after</p>
              </div>
              <div style={{ display: 'flex', gap: 'clamp(8px, 2.5vw, 20px)', flexWrap: 'nowrap', alignItems: 'center' }}>
                {[{ icon: '✓', color: '#10b981', label: 'Free to start' }, { icon: '🔒', color: '#64748b', label: 'Secure & Private' }].map(t => (
                  <span key={t.label} style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: '0.8rem', fontWeight: 600, color: '#475569', whiteSpace: 'nowrap' }}>
                    <span style={{ color: t.color }}>{t.icon}</span>{t.label}
                  </span>
                ))}
                <span style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: '0.8rem', fontWeight: 600, color: '#475569', whiteSpace: 'nowrap' }}>
                  via
                  <span style={{ background: '#072654', color: '#fff', borderRadius: 3, padding: '1px 5px', fontSize: '0.6rem', fontWeight: 900, letterSpacing: '0.02em', lineHeight: '1.6' }}>razorpay</span>
                </span>
              </div>
            </div>
            {/* Right: hero image + sticker */}
            <div style={{ position: 'relative' }}>
              <div className="am-sticker-wobble">
                <div className="am-sticker-persp">
                  <div className="am-sticker-flip">
                    {/* Front face */}
                    <div className="am-sticker-face">
                      <span style={{ fontSize: '1.15rem', fontWeight: 900, lineHeight: 1 }}>₹19</span>
                      <span style={{ fontSize: '0.5rem', fontWeight: 700, lineHeight: 1.3, opacity: 0.88 }}>per assessment</span>
                      <div style={{ width: 28, height: 1, background: 'rgba(255,255,255,0.35)', margin: '4px 0' }} />
                      <span style={{ fontSize: '0.65rem', fontWeight: 900, lineHeight: 1 }}>3 FREE</span>
                      <span style={{ fontSize: '0.48rem', fontWeight: 700, lineHeight: 1.4, opacity: 0.85 }}>to start</span>
                    </div>
                    {/* Back face — face rotateY(180deg) + parent rotateY(180deg) = 360deg, text reads correctly */}
                    <div className="am-sticker-face am-sticker-back">
                      <span style={{ fontSize: '1.15rem', fontWeight: 900, lineHeight: 1 }}>₹19</span>
                      <span style={{ fontSize: '0.5rem', fontWeight: 700, lineHeight: 1.3, opacity: 0.88 }}>per assessment</span>
                      <div style={{ width: 28, height: 1, background: 'rgba(255,255,255,0.35)', margin: '4px 0' }} />
                      <span style={{ fontSize: '0.65rem', fontWeight: 900, lineHeight: 1 }}>3 FREE</span>
                      <span style={{ fontSize: '0.48rem', fontWeight: 700, lineHeight: 1.4, opacity: 0.85 }}>to start</span>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ width: '100%', borderRadius: 20, overflow: 'hidden', boxShadow: '0 20px 60px rgba(79,70,229,0.13)' }}>
                <img
                  src="/hero-physio.png"
                  alt="Physiotherapist in a clinical setting"
                  style={{ width: '100%', height: 'clamp(280px,40vw,460px)', objectFit: 'cover', objectPosition: 'center top', display: 'block', transform: 'scale(1.2)', transformOrigin: 'center 30%' }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══ STATS TICKER ═══ */}
      <section className="am-stats-s" style={{ background: '#f8faff', borderTop: '1px solid #e2e8f0', borderBottom: '1px solid #e2e8f0', padding: '14px 0' }}>
        <div className="am-ticker">
          <div className="am-ticker-track">
            {[
              { val: assessmentCount >= 1000 ? '1,000+' : (assessmentCount > 0 ? assessmentCount.toLocaleString() : '1,000+'), label: 'Assessments Completed' },
              { val: '100+', label: 'Physiotherapists' },
              { val: '4.9/5', label: 'Average Rating' },
              { val: '3', label: 'Clinical Modules' },
              { val: '₹19', label: 'Per Assessment' },
              { val: '3 Free', label: 'To Get Started' },
            ].concat([
              { val: assessmentCount >= 1000 ? '1,000+' : (assessmentCount > 0 ? assessmentCount.toLocaleString() : '1,000+'), label: 'Assessments Completed' },
              { val: '100+', label: 'Physiotherapists' },
              { val: '4.9/5', label: 'Average Rating' },
              { val: '3', label: 'Clinical Modules' },
              { val: '₹19', label: 'Per Assessment' },
              { val: '3 Free', label: 'To Get Started' },
            ]).map((s, i) => (
              <div key={i} ref={i === 0 ? counterRef : null} className="am-ticker-item">
                <span style={{ fontSize: 'clamp(1rem,2vw,1.25rem)', fontWeight: 900, lineHeight: 1, background: 'linear-gradient(135deg,#2563eb,#4f46e5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
                  {s.val}
                </span>
                <span style={{ fontWeight: 600, fontSize: '0.8rem', color: '#475569' }}>{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══ HOW IT WORKS ═══ */}
      <section className="am-section" style={{ background: '#fff' }}>
        <div className="am-container">
          <div className="am-reveal" style={{ textAlign: 'center', marginBottom: 'clamp(36px,5vw,56px)' }}>
            <div style={{ fontSize: '0.68rem', fontWeight: 700, letterSpacing: '0.09em', textTransform: 'uppercase', color: '#2563eb', marginBottom: 12 }}>How it works</div>
            <h2 style={{ fontSize: 'clamp(1.8rem,3.5vw,2.8rem)', fontWeight: 900, letterSpacing: '-0.04em', margin: '0 0 12px', color: '#0f172a', lineHeight: 1.1 }}>From intake to report in minutes.</h2>
            <p style={{ fontSize: '0.95rem', color: '#64748b', margin: 0, lineHeight: 1.7, maxWidth: 420, marginLeft: 'auto', marginRight: 'auto' }}>No complex setup. Just open and start assessing.</p>
          </div>
          <div className="am-hiw-grid">
            {/* Left: step list */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4, paddingTop: 8 }}>
              {[
                { num: '01', title: 'Pick your module', desc: 'Choose Musculoskeletal, Neurological, or Cardiopulmonary — the form adapts to your specialty.' },
                { num: '02', title: 'Fill the assessment', desc: 'Guided subjective form captures the full clinical picture — history, ROM, special tests, and more.' },
                { num: '03', title: 'AI generates your report', desc: 'Primary diagnosis, differential list, phase classification, prognosis, and evidence-based treatment plan.' },
                { num: '04', title: 'Refine & export PDF', desc: 'Ask follow-up questions, refine the plan, and export a clean professional PDF for your records.' },
              ].map((step, i) => (
                <div key={step.num} className={`am-hiw-step${activeStep === i ? ' active' : ''}`} onClick={() => { setPanelFading(true); setTimeout(() => { setActiveStep(i); setPanelFading(false); }, 280); }}>
                  <div className="am-hiw-num">{step.num}</div>
                  <div style={{ flex: 1 }}>
                    <h3>{step.title}</h3>
                    {activeStep === i && (
                      <>
                        <p>{step.desc}</p>
                        <div className="am-hiw-progress"><div className="am-hiw-progress-fill" key={i} /></div>
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
            {/* Right: live preview panel */}
            <div className={`am-hiw-panel${panelFading ? ' fading' : ''}`}>
              {activeStep === 0 && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  <div style={{ fontSize: '0.7rem', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 4 }}>Select a clinical module</div>
                  {[
                    { icon: '🦴', label: 'Musculoskeletal', sub: 'Shoulder, Knee, Spine, Hip…', color: '#4f46e5', bg: '#eef2ff', border: '#c7d2fe', active: true },
                    { icon: '🧠', label: 'Neurological', sub: 'CVA, SCI, Parkinson\'s, MS…', color: '#7c3aed', bg: '#f5f3ff', border: '#ddd6fe', active: false },
                    { icon: '🫁', label: 'Cardiopulmonary', sub: 'Post-surgical, COPD, CHF…', color: '#0891b2', bg: '#ecfeff', border: '#a5f3fc', active: false },
                  ].map(m => (
                    <div key={m.label} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '13px 16px', background: m.active ? m.bg : '#f8fafc', border: `1.5px solid ${m.active ? m.border : '#e2e8f0'}`, borderRadius: 12, transition: 'all 0.18s' }}>
                      <span style={{ fontSize: '1.3rem' }}>{m.icon}</span>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: 700, fontSize: '0.88rem', color: m.active ? m.color : '#64748b' }}>{m.label}</div>
                        <div style={{ fontSize: '0.7rem', color: '#94a3b8' }}>{m.sub}</div>
                      </div>
                      {m.active && <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={m.color} strokeWidth="2.5" strokeLinecap="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>}
                    </div>
                  ))}
                </div>
              )}
              {activeStep === 1 && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
                  <div style={{ fontSize: '0.7rem', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 2 }}>Subjective Assessment · Shoulder</div>
                  {[
                    { label: 'Chief Complaint', val: 'Right shoulder pain, 6 weeks', filled: true },
                    { label: 'Region', val: 'Shoulder — Subacromial', filled: true },
                    { label: 'Onset', val: 'Gradual, after overhead work', filled: true },
                    { label: 'Pain Score (NRS)', val: '6 / 10 at rest', filled: true },
                    { label: 'Special Tests', val: '', filled: false },
                  ].map(f => (
                    <div key={f.label}>
                      <div style={{ fontSize: '0.63rem', fontWeight: 700, color: '#64748b', marginBottom: 3 }}>{f.label}</div>
                      <div style={{ background: f.filled ? '#f0f9ff' : '#f8fafc', border: `1px solid ${f.filled ? '#bae6fd' : '#e2e8f0'}`, borderRadius: 8, padding: '8px 12px', fontSize: '0.78rem', color: f.filled ? '#0369a1' : '#cbd5e1', fontWeight: f.filled ? 600 : 400 }}>
                        {f.filled ? f.val : 'Fill in…'}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {activeStep === 2 && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 11 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 2 }}>
                    <div style={{ width: 28, height: 28, borderRadius: 8, background: '#eff6ff', border: '1px solid #bfdbfe', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.9rem' }}>🤖</div>
                    <div style={{ fontSize: '0.7rem', fontWeight: 700, color: '#2563eb', textTransform: 'uppercase', letterSpacing: '0.07em' }}>AI Assessment Report</div>
                  </div>
                  {[
                    { label: 'Primary Diagnosis', val: 'Subacromial Impingement Syndrome — Stage II', accent: '#2563eb', bg: '#eff6ff', border: '#bfdbfe' },
                    { label: 'Phase & Prognosis', val: 'Sub-acute · Good prognosis · 6–10 weeks', accent: '#059669', bg: '#ecfdf5', border: '#bbf7d0' },
                    { label: 'Differentials', val: 'Rotator cuff partial tear, AC joint OA', accent: '#64748b', bg: '#f8fafc', border: '#e2e8f0' },
                    { label: 'Treatment Phase', val: 'Phase 1 — Pain reduction & ROM restoration', accent: '#7c3aed', bg: '#f5f3ff', border: '#ddd6fe' },
                  ].map(item => (
                    <div key={item.label} style={{ background: item.bg, border: `1px solid ${item.border}`, borderRadius: 10, padding: '10px 14px' }}>
                      <div style={{ fontSize: '0.6rem', fontWeight: 700, color: item.accent, textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 3 }}>{item.label}</div>
                      <div style={{ fontSize: '0.78rem', color: '#0f172a', fontWeight: 600, lineHeight: 1.4 }}>{item.val}</div>
                    </div>
                  ))}
                </div>
              )}
              {activeStep === 3 && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  <div style={{ fontSize: '0.7rem', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 2 }}>Chat & Refine</div>
                  {[
                    { from: 'ai', text: 'Report ready. Primary impression: Subacromial Impingement Syndrome Stage II.' },
                    { from: 'user', text: 'Can you add a home exercise program for phase 1?' },
                    { from: 'ai', text: 'Added: pendulum exercises 3×10, scapular retraction 3×15, and rotator cuff isometrics. No pain provocation.' },
                  ].map((msg, i) => (
                    <div key={i} style={{ display: 'flex', justifyContent: msg.from === 'user' ? 'flex-end' : 'flex-start' }}>
                      <div style={{ maxWidth: '80%', background: msg.from === 'user' ? '#2563eb' : '#f1f5f9', color: msg.from === 'user' ? '#fff' : '#0f172a', padding: '9px 13px', borderRadius: msg.from === 'user' ? '14px 14px 4px 14px' : '14px 14px 14px 4px', fontSize: '0.77rem', lineHeight: 1.55 }}>{msg.text}</div>
                    </div>
                  ))}
                  <div style={{ textAlign: 'center', marginTop: 6 }}>
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 7, background: '#ecfdf5', border: '1px solid #bbf7d0', borderRadius: 8, padding: '9px 16px', fontSize: '0.76rem', fontWeight: 700, color: '#059669', cursor: 'pointer' }}>
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14,2 14,8 20,8"/></svg>
                      Export as PDF
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* ═══ WHAT YOU GET ═══ */}
      <section className="am-section" style={{ background: '#f8faff' }}>
        <div className="am-container">
          <div className="am-reveal" style={{ textAlign: 'center', marginBottom: 'clamp(36px,5vw,56px)' }}>
            <div style={{ fontSize: '0.68rem', fontWeight: 700, letterSpacing: '0.09em', textTransform: 'uppercase', color: '#2563eb', marginBottom: 12 }}>What you get</div>
            <h2 style={{ fontSize: 'clamp(1.8rem,3.5vw,2.8rem)', fontWeight: 900, letterSpacing: '-0.04em', margin: '0 0 12px', color: '#0f172a', lineHeight: 1.1 }}>One ₹19 session.<br/>Full clinical value.</h2>
            <p style={{ fontSize: '0.95rem', color: '#64748b', margin: 0, lineHeight: 1.7, maxWidth: 420, marginLeft: 'auto', marginRight: 'auto' }}>No subscription needed until you're ready. Every session unlocks all of this.</p>
          </div>
          <div className="am-wyg-bento am-reveal">
            {[
              { icon: '📋', title: 'Structured Assessment Form', desc: 'Guided subjective + objective form — prompts, red flags, and clinical suggestions built in.' },
              { icon: '🧬', title: 'AI Diagnosis', desc: 'Primary impression, differential list, and phase classification generated instantly.' },
              { icon: '📊', title: 'Prognosis', desc: 'Evidence-informed recovery timeline and expected outcomes.' },
              { icon: '💊', title: 'Treatment Plan', desc: 'Phased, evidence-based interventions with exercises and progressions.' },
              { icon: '🎯', title: 'SMART Goals', desc: 'Measurable, time-bound goals tailored to the assessment.' },
              { icon: '📏', title: 'Outcome Measures', desc: 'Validated tools matched to specialty — DASH, Berg, Borg, and more.' },
              { icon: '📄', title: 'PDF Export', desc: 'Clean professional report ready to file or share instantly.' },
            ].map(f => (
              <div key={f.title} style={{ display: 'flex', alignItems: 'flex-start', gap: 11, background: isDark ? '#1e293b' : '#fff', border: `1px solid ${isDark ? '#334155' : '#e2e8f0'}`, borderRadius: 13, padding: '13px 15px', boxShadow: isDark ? '0 1px 4px rgba(0,0,0,0.2)' : '0 1px 4px rgba(15,23,42,0.04)', transition: 'box-shadow 0.18s,border-color 0.18s' }}
                onMouseEnter={e => { e.currentTarget.style.boxShadow = isDark ? '0 4px 16px rgba(37,99,235,0.2)' : '0 4px 16px rgba(37,99,235,0.09)'; e.currentTarget.style.borderColor = '#2563eb'; }}
                onMouseLeave={e => { e.currentTarget.style.boxShadow = isDark ? '0 1px 4px rgba(0,0,0,0.2)' : '0 1px 4px rgba(15,23,42,0.04)'; e.currentTarget.style.borderColor = isDark ? '#334155' : '#e2e8f0'; }}
              >
                <div style={{ width: 34, height: 34, borderRadius: 9, background: isDark ? '#1e3a5f' : '#eff6ff', border: `1px solid ${isDark ? '#2563eb' : '#bfdbfe'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.95rem', flexShrink: 0 }}>{f.icon}</div>
                <div>
                  <div style={{ fontWeight: 800, fontSize: '0.82rem', color: isDark ? '#f1f5f9' : '#0f172a', marginBottom: 3 }}>{f.title}</div>
                  <div style={{ fontSize: '0.72rem', color: isDark ? '#94a3b8' : '#64748b', lineHeight: 1.55 }}>{f.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══ PRICING (DARK) ═══ */}
      <div style={{ background: '#06080f', position: 'relative', overflow: 'hidden' }}>
        <div style={grainOverlay} />
        <div style={{ position: 'absolute', width: 700, height: 700, borderRadius: '50%', background: 'radial-gradient(circle,rgba(79,70,229,0.12) 0%,transparent 70%)', top: '10%', left: '50%', transform: 'translateX(-50%)', pointerEvents: 'none' }} />

        {/* PRICING */}
        <section className="am-section" style={{ position: 'relative', zIndex: 2, paddingTop: 0 }}>
        <div className="am-container">
          <div style={{ textAlign: 'center', marginBottom: 'clamp(32px,5vw,52px)' }}>
            <h2 style={{ fontSize: 'clamp(1.5rem,3vw,2.4rem)', fontWeight: 900, letterSpacing: '-0.03em', margin: '12px 0 14px', color: '#f1f5f9' }}>Start free. Upgrade when you're ready.</h2>
            <p style={{ fontSize: '0.95rem', color: '#64748b', margin: 0, lineHeight: 1.7 }}>No hidden costs. No feature tricks. Every plan includes the full clinical framework.</p>
          </div>
          <div className="am-pricing-grid-lp">
            {[
              { name: 'Free', sub: 'Always free', price: '₹0', note: 'No card required', accent: '#34d399', dark: false, recommended: false, desc: '3 lifetime full assessments — form, AI, refine, chat, and PDF. After that, forms are locked until you pay.', features: ['3 full assessments (form + AI + PDF)', 'All 3 clinical modules', 'No card required'], btnLabel: 'Get started free' },
              { name: 'Pay per use', sub: 'No subscription', price: '₹19', note: 'per assessment', accent: '#6366f1', dark: false, recommended: false, desc: 'Each ₹19 unlocks one complete assessment — form access, AI, refine, chat & PDF. Forms stay locked until payment.', features: ['Form access unlocked for that session', 'AI diagnosis & treatment plan', 'Refine & chat', 'PDF download', 'No expiry'], btnLabel: 'Get started free' },
              { name: 'Student', sub: 'Yearly', price: '₹1,299', note: 'per year', accent: '#6366f1', dark: true, recommended: false, desc: 'Unlimited AI diagnoses, full history sync, and PDF export all year.', features: ['Unlimited AI diagnoses', 'PDF reports', 'History synced', 'All 3 modules'], btnLabel: 'Choose Student' },
              { name: 'Clinician', sub: 'Recommended', price: '₹1,999', note: 'per year', accent: '#a78bfa', dark: true, recommended: true, desc: 'Everything in Student plus deeper clinical reasoning for sharper diagnoses.', features: ['Deeper clinical reasoning', 'Everything in Student', 'Unlimited history', 'PDF export'], btnLabel: 'Choose Clinician' },
            ].map(plan => (
              <div key={plan.name} className="am-price-card" style={{ background: plan.dark ? (plan.recommended ? 'linear-gradient(160deg,#1e1b4b,#1a1040)' : '#131929') : '#fff', border: plan.recommended ? '1px solid rgba(167,139,250,0.45)' : plan.dark ? '1px solid rgba(255,255,255,0.07)' : '1px solid #e2e8f0', borderRadius: 18, padding: 'clamp(18px,2vw,26px)', display: 'flex', flexDirection: 'column', gap: 14, position: 'relative', boxShadow: plan.recommended ? '0 0 0 1px rgba(167,139,250,0.2),0 16px 40px rgba(0,0,0,0.35)' : plan.dark ? '0 8px 24px rgba(0,0,0,0.25)' : '0 2px 12px rgba(15,23,42,0.06)' }}>
                {plan.recommended && <div style={{ position: 'absolute', top: -11, left: '50%', transform: 'translateX(-50%)', background: 'linear-gradient(135deg,#7c3aed,#6366f1)', borderRadius: 99, padding: '3px 12px', fontSize: '0.62rem', fontWeight: 800, color: '#fff', whiteSpace: 'nowrap' }}>Recommended</div>}
                <div>
                  <div style={{ fontSize: '1.05rem', fontWeight: 900, color: plan.dark ? '#f1f5f9' : (isDark ? '#f1f5f9' : '#0f172a'), marginBottom: 2 }}>{plan.name}</div>
                  <div style={{ fontSize: '0.7rem', color: plan.recommended ? '#a78bfa' : (isDark && !plan.dark ? '#94a3b8' : '#64748b'), fontWeight: 600 }}>{plan.sub}</div>
                </div>
                <div style={{ paddingBottom: 14, borderBottom: `1px solid ${plan.dark ? 'rgba(255,255,255,0.07)' : (isDark ? '#334155' : '#f1f5f9')}` }}>
                  <div style={{ fontSize: 'clamp(1.7rem,3vw,2.2rem)', fontWeight: 900, color: plan.dark ? '#f8fafc' : (isDark ? '#f1f5f9' : '#0f172a'), lineHeight: 1, marginBottom: 3 }}>{plan.price}</div>
                  <div style={{ fontSize: '0.66rem', color: isDark && !plan.dark ? '#94a3b8' : '#64748b', fontWeight: 600 }}>{plan.note}</div>
                </div>
                <div style={{ fontSize: '0.78rem', color: plan.dark ? '#94a3b8' : (isDark ? '#94a3b8' : '#64748b'), lineHeight: 1.6, flex: 1 }}>{plan.desc}</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
                  {plan.features.map(f => (
                    <div key={f} style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: '0.75rem', color: plan.dark ? '#cbd5e1' : (isDark ? '#94a3b8' : '#475569'), fontWeight: 600 }}>
                      <span style={{ color: plan.accent, fontWeight: 900, fontSize: '0.7rem' }}>✓</span>{f}
                    </div>
                  ))}
                </div>
                <button className="am-price-btn" onClick={() => setShowAuth(true)} style={{ width: '100%', padding: '11px', borderRadius: 10, fontWeight: 800, fontSize: '0.84rem', cursor: 'pointer', border: 'none', transition: 'all 0.18s', background: plan.dark ? (plan.recommended ? 'linear-gradient(135deg,#7c3aed,#a78bfa)' : 'rgba(255,255,255,0.1)') : plan.name === 'Free' ? (isDark ? '#334155' : '#f1f5f9') : `linear-gradient(135deg,${plan.accent},#4f46e5)`, color: plan.dark ? '#fff' : plan.name === 'Free' ? (isDark ? '#f1f5f9' : '#0f172a') : '#fff' }}>{plan.btnLabel}</button>
              </div>
            ))}
          </div>
          <p style={{ textAlign: 'center', marginTop: 24, fontSize: '0.75rem', color: '#475569' }}>Yearly plans billed once — no auto-renewal surprises</p>
        </div>
      </section>

      </div>{/* end pricing dark zone */}

      {/* ═══ SOCIAL PROOF ═══ */}
      <section className="am-social-s" style={{ background: '#f8faff', padding: 'clamp(48px,7vw,88px) clamp(20px,5vw,40px)', borderTop: '1px solid #e2e8f0' }}>
        <div className="am-container am-reveal" style={{ textAlign: 'center' }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#fff', borderRadius: 99, padding: '8px 18px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0' }}>
              <span style={{ fontSize: '0.82rem' }}><span className="am-star">⭐</span><span className="am-star">⭐</span><span className="am-star">⭐</span><span className="am-star">⭐</span><span className="am-star">⭐</span></span>
              <span style={{ fontWeight: 700, fontSize: '0.82rem', color: '#0f172a' }}>4.9 / 5 · 100+ physiotherapists</span>
            </div>
            <p style={{ margin: 0, fontSize: 'clamp(1rem,2vw,1.25rem)', color: '#0f172a', fontWeight: 700, maxWidth: 540, lineHeight: 1.6 }}>
              "Built for clinicians who want to think faster and document better."
            </p>
          </div>
        </div>
      </section>

      {/* ═══ FINAL CTA ═══ */}
      <section style={{ background: 'linear-gradient(135deg,#1e40af 0%,#2563eb 50%,#4f46e5 100%)', padding: 'clamp(64px,9vw,100px) clamp(20px,5vw,40px)' }}>
        <div className="am-container am-reveal" style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 24 }}>
          <h2 style={{ fontSize: 'clamp(1.8rem,4vw,3.2rem)', fontWeight: 900, letterSpacing: '-0.04em', color: '#fff', margin: 0, maxWidth: 560, lineHeight: 1.1 }}>
            Ready to transform your clinical assessments?
          </h2>
          <p style={{ fontSize: 'clamp(0.9rem,1.3vw,1.05rem)', color: 'rgba(255,255,255,0.75)', margin: 0, lineHeight: 1.7, maxWidth: 380 }}>Join 100+ physiotherapists. Start free — no card needed.</p>
          <div role="button" tabIndex={0} onClick={() => setShowAuth(true)} onKeyDown={e => e.key === 'Enter' && setShowAuth(true)}
            style={{ display: 'inline-flex', alignItems: 'center', gap: 12, background: '#fff', borderRadius: 12, padding: '15px 30px', cursor: 'pointer', border: 'none', transition: 'transform 0.18s,box-shadow 0.18s', boxShadow: '0 4px 24px rgba(0,0,0,0.25)' }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.3)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 24px rgba(0,0,0,0.25)'; }}
          >
            <div style={{ width: 26, height: 26, borderRadius: 7, background: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{googleSvg}</div>
            <span style={{ fontSize: '0.97rem', fontWeight: 800, color: '#0f172a' }}>Get started free with Google</span>
          </div>
          <p style={{ margin: 0, fontSize: '0.72rem', color: 'rgba(255,255,255,0.45)', fontWeight: 500 }}>3 free assessments · ₹19/assessment after</p>
        </div>
      </section>

      {/* ═══ FOOTER ═══ */}
      <footer style={{ background: '#0f172a', borderTop: '1px solid rgba(255,255,255,0.06)', padding: 'clamp(20px,3vw,32px) clamp(20px,5vw,40px)' }}>
        <div className="am-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <img src="/logo192.png" alt="AssessMonk" style={{ width: 26, height: 26, borderRadius: 7, objectFit: 'contain', flexShrink: 0 }} />
            <span style={{ fontWeight: 800, fontSize: '0.88rem', color: '#f1f5f9' }}>AssessMonk</span>
            <span style={{ color: '#334155', fontSize: '0.7rem', marginLeft: 6 }}>© 2026 · Built for Clinicians</span>
          </div>
          <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
            {[['Privacy','/privacy'],['Terms','/terms'],['Contact','/contact'],['Refund','/refund'],['Disclaimer','/disclaimer']].map(([label, to]) => (
              <Link key={to} to={to} style={{ fontSize: '0.75rem', color: '#475569', textDecoration: 'none', fontWeight: 500 }} onMouseEnter={e => e.currentTarget.style.color = '#94a3b8'} onMouseLeave={e => e.currentTarget.style.color = '#475569'}>{label}</Link>
            ))}
          </div>
        </div>
      </footer>

    </div>
  );

}
